// File for logic corresponding to main element component
import './main.scss';



// WEBPACK FOOTER //
// ./client/src/components/main/index.js